import { useEffect } from "react";

const SITE_URL = "https://www.dsglobalmachines.com";

function setMeta(name, content, attr = "name") {
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function SEO({ title, description, path = "/", keywords = [], schema }) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords.join(", "));
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", canonicalUrl, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    const id = "page-json-ld";
    document.getElementById(id)?.remove();
    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema || {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "DS Global Machines",
      url: SITE_URL,
      email: "info@dsglobalmachines.com",
      telephone: "+1-385-461-4051",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Eagle Mountain",
        addressRegion: "UT",
        addressCountry: "US",
      },
      areaServed: "Worldwide",
      makesOffer: keywords.map((keyword) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: keyword } })),
    });
    document.head.appendChild(script);
  }, [title, description, path, keywords, schema]);

  return null;
}
